import classNames from 'classnames';
import React, { FC, memo } from 'react';

import styles from './TruncatedText.styles.m.css';

const DEFAULT_SAVED_SYMBOLS_NUMBER = 12;

interface ITruncatedTextProps {
  children: string;
  savedSymbolsNumber?: number;
  className?: string;
}

export const TruncatedText: FC<ITruncatedTextProps> = memo<ITruncatedTextProps>((props) => {
  const { children = '', savedSymbolsNumber = DEFAULT_SAVED_SYMBOLS_NUMBER, className } = props;

  if (children.length <= savedSymbolsNumber) {
    return <span className={className}>{children}</span>;
  }

  let leftPart = children.slice(0, Math.max(0, children.length - savedSymbolsNumber));
  // flexbox not displayed ending spaces
  if (leftPart[leftPart.length - 1] === ' ') {
    leftPart = `${leftPart.slice(0, -1)}\u00A0`;
  }

  let rightPart = children.slice(-savedSymbolsNumber);
  // flexbox not displayed starting spaces
  if (rightPart[0] === ' ') {
    rightPart = `\u00A0${rightPart.slice(1)}`;
  }

  return (
    <span
      className={classNames(styles.container, className)}
      title={children}
    >
      <span className={styles.leftPart}>{leftPart}</span>
      <span className={styles.rightPart}>{rightPart}</span>
    </span>
  );
});
